import type {
  KeywordListingPageQuery,
  KeywordListingPageQueryVariables,
} from 'src/types';
import keywordListingQuery from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useKeywordListingPageQuery(
  variables: KeywordListingPageQueryVariables
) {
  return usePageQuery<KeywordListingPageQuery>({
    query: keywordListingQuery,
    routeName: 'keywordListingPage',
    variables,
  });
}
